import { useMatchedBreakpoints } from "./BreakpointProvider";
import { isNil, isObject } from "../../shared";
// Inspired by https://github.com/adobe/react-spectrum/blob/main/packages/%40react-spectrum/utils/src/styleProps.ts
// Our breakpoints strategy have been inspired by how Tailwind does it https://tailwindcss.com/docs/responsive-design.
export function parseResponsiveValue(value, matchedBreakpoints) {
  if (isObject(value)) {
    for (let i = 0; i < matchedBreakpoints.length; i++) {
      const responsiveValue = value[matchedBreakpoints[i]];

      if (!isNil(responsiveValue)) {
        return responsiveValue;
      }
    }

    return value["base"];
  }

  return value;
}
export function useResponsiveValue(value) {
  const matchedBreakpoints = useMatchedBreakpoints();
  return parseResponsiveValue(value, matchedBreakpoints);
}